module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1520-d34035655b50c0e4466df96979ae99d3.png";